{
  "name": "dofs",
  "description": "A filesystem for Cloudflare Durable Objects.",
  "version": "0.1.0",
  "type": "module",
  "author": {
    "name": "Ben Allfree",
    "url": "https://x.com/benallfree"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/benallfree/dofs"
  },
  "keywords": [
    "cloudflare",
    "durable objects",
    "dofs",
    "filesystem",
    "file system",
    "file-system",
    "file-system-api",
    "file-system-api-client",
    "file-system-api-server",
    "file-system-api-client-server"
  ],
  "homepage": "https://github.com/benallfree/dofs/tree/main/packages/dofs",
  "scripts": {
    "build": "tsdown",
    "dev": "tsdown --watch"
  },
  "main": "./dist/Fs.js",
  "module": "./dist/Fs.js",
  "types": "./dist/Fs.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./hono": {
      "import": "./dist/hono.js",
      "types": "./dist/hono.d.ts"
    }
  },
  "bin": {
    "dofs": "./dist/cli/index.js"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "commander": "^14.0.0",
    "neofuse": "^0.0.1-rc.3"
  },
  "peerDependencies": {
    "hono": "^4.7.11"
  },
  "devDependencies": {
    "@types/node": "^22.15.30",
    "tsdown": "^0.12.7"
  }
}
